import { FC } from 'react';
import styled from 'styled-components';

import { CollapsibleContent, CollapsibleContentArrow } from 'ui/collapsibleContent';
import { colors, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

import { JsonBranchProps } from '../types';
import { Leaf } from './Leaf';

type BranchContainerProps = {
  isCollapsed: boolean;
  hasChildren: boolean;
};

const BranchContainer = styled.div<BranchContainerProps>`
  padding-bottom: ${({ isCollapsed, hasChildren }) =>
    !isCollapsed && hasChildren ? spacing.threeQuarter : 0};
`;

type BranchValueProps = {
  depth?: number;
  className?: string;
};

const BranchValue = styled(CollapsibleContent)<BranchValueProps>`
  border-left: 1px solid ${colors.grey15};
  margin-left: ${spacing.plusQuarter};
  padding-left: ${spacing.half};

  .json-property-value {
    margin-left: ${({ depth = 1 }) => `-${pxToRem(spacing.scaleBase(depth * 1.25))}`};
  }
`;

export const Branch: FC<React.PropsWithChildren<JsonBranchProps>> = ({
  CollapseButton,
  children,
  isCollapsed,
  label: mainLabel,
  value: mainValue,
  depth = 0,
  type,
}) => {
  const arrayLength = Array.isArray(mainValue) ? mainValue.length : 0;
  const objectLength = Object.values(mainValue).length;

  const caption = arrayLength ? `Array [${arrayLength}]` : '';

  return (
    <BranchContainer
      isCollapsed={isCollapsed}
      hasChildren={!!arrayLength || !!objectLength}
      className="json-branch json-row"
      data-test="json-branch-table"
    >
      <Leaf
        label={mainLabel}
        startDecoration={
          <CollapseButton>
            <CollapsibleContentArrow
              isCollapsed={isCollapsed}
              height={16}
              width={16}
              arrowStart={0}
              arrowEnd={180}
            />
          </CollapseButton>
        }
        type={type}
        value={caption}
      />
      <BranchValue isCollapsed={isCollapsed} depth={depth} data-test="json-branch-value">
        {children}
      </BranchValue>
    </BranchContainer>
  );
};
